
// export default class CustomEditor extends ClassicEditorBase {}

// CustomEditor.builtinPlugins = [
//   ...ClassicEditorBase.builtinPlugins,
//   Image,
//   ImageToolbar,
// ];

// CustomEditor.defaultConfig = {
//   toolbar: {
//     items: [
//       'heading', '|',
//       'bold', 'italic', 'link', '|',
//       'bulletedList', 'numberedList', '|',
//       'insertImage', // ✅ button to insert image by URL
//       'undo', 'redo'
//     ]
//   },
//   image: {
//     toolbar: [
//       'imageStyle:inline',
//       'imageStyle:block',
//       'imageStyle:side',
//       '|',
//       'toggleImageCaption',
//       'imageTextAlternative'
//     ]
//   },
//   language: 'en',
// };

// src/customEditor/CustomEditor.js
// import ClassicEditorBase from '@ckeditor/ckeditor5-build-classic';

// import { 
//   Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize
// } from '@ckeditor/ckeditor5-image';

// import { Base64UploadAdapter } from '@ckeditor/ckeditor5-upload';

// export default class CustomEditor extends ClassicEditorBase {}

// CustomEditor.builtinPlugins = [
//   ...ClassicEditorBase.builtinPlugins,
//   Image,
//   ImageToolbar,
//   ImageCaption,
//   ImageStyle,
//   ImageResize,
//   Base64UploadAdapter,
// ];

// CustomEditor.defaultConfig = {
//   toolbar: {
//     items: [
//       'heading', '|',
//       'bold', 'italic', 'link', '|',
//       'bulletedList', 'numberedList', '|',
//       'uploadImage', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side', '|',
//       'undo', 'redo'
//     ]
//   },
//   image: {
//     toolbar: [
//       'imageStyle:inline',
//       'imageStyle:block',
//       'imageStyle:side',
//       '|',
//       'toggleImageCaption',
//       'imageTextAlternative'
//     ]
//   },
//   language: 'en',
// };

// import ClassicEditorBase from '@ckeditor/ckeditor5-build-classic';

// import { 
//   Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize, ImageUpload 
// } from '@ckeditor/ckeditor5-image';

// import { Base64UploadAdapter } from '@ckeditor/ckeditor5-upload';

// export default class CustomEditor extends ClassicEditorBase {}

// CustomEditor.builtinPlugins = [
//   ...ClassicEditorBase.builtinPlugins,
//   Image,
//   ImageToolbar,
//   ImageCaption,
//   ImageStyle,
//   ImageResize,
//   ImageUpload,
//   Base64UploadAdapter,  // <-- handles local uploads
// ];

// CustomEditor.defaultConfig = {
//   toolbar: {
//     items: [
//       'heading', '|',
//       'bold', 'italic', 'link', '|',
//       'bulletedList', 'numberedList', '|',
//       'uploadImage', // <-- Upload button
//       'imageStyle:inline', 'imageStyle:block', 'imageStyle:side', '|',
//       'undo', 'redo'
//     ]
//   },
//   image: {
//     toolbar: [
//       'imageStyle:inline',
//       'imageStyle:block',
//       'imageStyle:side',
//       '|',
//       'toggleImageCaption',
//       'imageTextAlternative'
//     ]
//   },
//   language: 'en',
// };

// CustomEditor.js

// import ClassicEditorBase from '@ckeditor/ckeditor5-build-classic';
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';

// // Extend ClassicEditor to include Base64 adapter
// export default class ClassicEditor extends ClassicEditorBase {}
// ClassicEditor.builtinPlugins = [
//   ...ClassicEditorBase.builtinPlugins,
//   Base64UploadAdapter
// ];
  
  
// import ClassicEditorBase from '@ckeditor/ckeditor5-build-classic';
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';

// class ClassicEditor extends ClassicEditorBase {}
// ClassicEditor.builtinPlugins = [
//     ...ClassicEditorBase.builtinPlugins,
//     Base64UploadAdapter
// ];

import { Api, UploadFile } from '../../webservices'; 

// export default function MyCustomUploadAdapterPlugin(editor) {
//   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//     return new Base64UploadAdapter(loader);
//   };
// }

// class Base64UploadAdapter {
//   constructor(loader) {
//     this.loader = loader;
//   }          
    
//   upload() {
//     return this.loader.file.then(
//       (file) =>
//         new Promise((resolve, reject) => {
//           const reader = new FileReader();
//           reader.onload = () => resolve({ default: reader.result });
//           reader.onerror = (err) => reject(err);
//           reader.readAsDataURL(file);
//         })
//     );
//   }  

//   abort() {
//   if (this.loader) {
//     // console.log("Upload aborted");
//   }
// }

// }

//     const uploadMulti = async (file) => {
//         const token = localStorage.getItem('token');
//         const formData = new FormData();
//         formData.append('document', file);
//         formData.append('directoryName', 'profile');
//         try {
//             const response = await UploadFile('resume/upload_resume', formData, token);
//             if (response.status === 200 && response.data.code === 200) {
//                 // setProfileStore(response.data.filePath)
//                 const uploadedImageUrl = response.data.filePath;
//                 //   setProfileImage(uploadedImageUrl);  
//                 // UploadImage(uploadedImageUrl)
//                 //   setImagePreview(URL.createObjectURL(file));  
//             } else {
//                 //   toast.warn(response.data.status + '!');
//             }
//         } catch (error) {
//             // toast.warn('Error uploading the image!');
//         }
//     };

class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader;
  }

  // async upload() {
  //   const file = await this.loader.file;

  //   const token = localStorage.getItem('token');
  //   const formData = new FormData();
  //   formData.append('document', file);
  //   formData.append('directoryName', 'profile');

  //   try {
  //     const response = await UploadFile('resume/upload_resume', formData, token);

  //     if (response.status === 200 && response.data.code === 200) {
  //       return { default: response.data.filePath };
  //     }
  //     throw new Error(response.data.status || 'Upload failed');
  //   } catch (err) {
  //     console.error('Image upload failed:', err);
  //     throw err;
  //   }
  // }
  
async upload() {
    const file = await this.loader.file;
    const token = localStorage.getItem('token'); 
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'profile');

    try {
      const response = await UploadFile('resume/upload_resume', formData, token);

      if (response.status === 200 && response.data.code === 200) {
        return { default: response.data.filePath }; 
      }

      throw new Error(response.data.status || 'Upload failed');
    } catch (err) {
      console.error('Image upload failed:', err);
      throw err;
    }
  }

   abort() {
  if (this.loader) {
    // console.log("Upload aborted");
  }
}
}

export default function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
}
